import React, { useState, useEffect } from "react";
import {
  fetchDomainName,
  updateDomainName,
} from "../../services/domainService";
import styles from "./DomainSetter.module.css";

const DomainSetter = () => {
  const [domainName, setDomainName] = useState("");
  const [message, setMessage] = useState("");

  /**
   * Fetch the current domain name from the server on component mount.
   * Sets the `domainName` state with the fetched value.
   * Displays an error message if fetching fails.
   */
  useEffect(() => {
    const getDomainName = async () => {
      try {
        const data = await fetchDomainName();
        setDomainName(data.domainName);
      } catch {
        setMessage("Failed to fetch domain name.");
      }
    };
    getDomainName();
  }, []);

  /**
   * Handle domain name update when the user clicks the "Update" button.
   * Validates the input domain name and sends it to the server.
   * Provides feedback on whether the update was successful or not.
   */
  const handleUpdate = async () => {
    try {
      await updateDomainName(domainName);
      setMessage("Domain name updated successfully!");
    } catch {
      setMessage("Failed to update domain name.");
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Domain Name Management</h2>

      <input
        type="text"
        value={domainName}
        onChange={(e) => setDomainName(e.target.value)}
        placeholder="Enter domain name"
        className={styles.input}
      />
      <button onClick={handleUpdate} className={styles.submitButton}>
        Update
      </button>
      {message && <p className={styles.statusMessage}>{message}</p>}
    </div>
  );
};

export default DomainSetter;
